import { createReducer } from 'redux-create-reducer';
import {
  fetchZoneTemplatesAction,
  fetchZoneTemplatesSuccessAction,
  copyZoneAction,
  copyZoneActionSuccess,
} from '../actions/zoneTemplates';

const initialState = {
  choice: [],
  isFetching: false,
  isCopying: false,
};

export const zoneTemplateReducer = createReducer(initialState, {
  [fetchZoneTemplatesAction]: state => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [fetchZoneTemplatesSuccessAction]: (state, action) => {
    return {
      ...state,
      choice: action.payload,
      isFetching: false,
    };
  },
  [copyZoneAction]: state => {
    return {
      ...state,
      isCopying: true,
    };
  },
  [copyZoneActionSuccess]: (state, action) => {
    return {
      ...state,
      isCopying: false,
    };
  },
});

export default zoneTemplateReducer;

export const getIsFetching = state => state.zoneTemplates.isFetching;

export const getIsCopying = state => state.zoneTemplates.isCopying;

export const getZoneTemplates = state => state.zoneTemplates.choice;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/reducers/zoneTemplates.js